/*
 * @Author: 丨小小风离丨
 * @Date: 2023-08-28 09:04:17
 * @LastEditTime: 2024-04-25 20:15:46
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\components\lg_select\index.tsx
 * @Description: 
 */
import "./index.scss";
import { Dropdown, Menu } from 'antd';
import { useEffect, useState } from 'react';

interface LgSelectProps {
    list: string[];
    change: (index: number) => void;
    index?: number;
    width?: number | string;
    container?: string;
    className?: string;
    children?: any;
    placeholder?: string;
}

export default function RsmSelect(props: LgSelectProps) {
    const [selectIndex, setSelectIndex] = useState(props?.index || 0);
    useEffect(() => {
        setSelectIndex(props?.index || 0)
    }, [props.index])


    function getItems() {
        let list = props.list || [];
        return list.map((item, index) => (
            <Menu.Item key={index}>
                <div
                    style={{ width: `${props.width || 100}${(props.width && Number(props?.width)) || !props.width ? 'px':''}` }}
                    className={`rsm_select_item ${index === selectIndex ? 'rsm_select_item_current' : ''}`}
                    onClick={() => {
                        setSelectIndex(index);
                        props.change(index);
                    }}
                    title={item}
                >
                    {item}
                </div>
            </Menu.Item>
        ));
    }

    return (
        <>
            <Dropdown
                className={`rsm_com_select ${props.className || ''}`}
                getPopupContainer={props.container ? () => document.getElementById(props.container) : undefined}
                overlay={<Menu className='rsm_com_select_menu'>{getItems()}</Menu>}
                trigger={['click']}
            >
                <div
                    title={props.list[selectIndex]}
                    style={{ width: `${props.width || 100}${(props.width && Number(props?.width)) || !props.width ? 'px':''}` }}
                    onClick={(e) => e.preventDefault()}
                    className={`${selectIndex === -1 ? 'rsm_select_item_placeholder' : ''}`}
                >
                    {selectIndex === -1 ? props.placeholder : props.list[selectIndex]}
                </div>
            </Dropdown>
        </>
    );
}
